module.exports = __webpack_public_path__ + "img/qrcode_for_cmptt.bf11fa4a.jpg";